"use strict";
/**
 * Created on 03 09 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReleaseItemPriceImpact_1 = require("../ReleaseItemPriceImpact");
/**
 * <p>Implementation of {@link AbstractReleaseItemPriceImpact} for {@link SelloutReleaseItem}.</p>
 *
 * @author JMe
 */


var SelloutReleaseItemPriceImpact =
/*#__PURE__*/
function (_ReleaseItemPriceImpa) {
  _inherits(SelloutReleaseItemPriceImpact, _ReleaseItemPriceImpa);

  /**
   * CTor.
   *
   * @param iId {@link AbstractReleaseItem.id}
   * @param realImpact Real impact of an item.
   */
  function SelloutReleaseItemPriceImpact(iId, realImpact) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemPriceImpact);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemPriceImpact).call(this, iId, realImpact));
    _this.iId = iId;
    _this.realImpact = realImpact;
    return _this;
  }

  return SelloutReleaseItemPriceImpact;
}(ReleaseItemPriceImpact_1.AbstractReleaseItemPriceImpact);

exports.SelloutReleaseItemPriceImpact = SelloutReleaseItemPriceImpact;